export default __webpack_public_path__ + "static/media/cat2-1-1.22f0c68a.jpg";